<template>
    <div
        class="v-modals z-50 inset-0 overflow-y-auto font-normal"
        :class="[nonFixed ? 'absolute' : 'fixed']"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div
            class="flex pt-4 px-4 pb-20 items-end justify-center min-h-screen text-center sm:block sm:p-0"
        >
            <div class="transition-modal-out fixed inset-0" aria-hidden="true"></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                &#8203;
            </span>

            <div
                :style="{ 'background-color': cookie.backColor }"
                class="transition-modal-in inline-block align-bottom rounded-lg text-left shadow-xl transform sm:my-8 sm:align-middle sm:max-w-lg sm:w-full p-4 sm:p-6"
            >
                <div class="absolute top-0 right-0 p-4 sm:p-6">
                    <button
                        @click="handleActionClick"
                        data-ec-close
                        type="button"
                        :style="{
                            color: cookie.buttonColor,
                        }"
                        class="hover:opacity-50 cursor-pointer"
                    >
                        <XIcon class="h-5 w-5" />
                    </button>
                </div>

                <div
                    :style="{
                        color: cookie.buttonColor,
                    }"
                    class="relative flex items-center justify-center h-12 w-12 rounded-lg overflow-hidden"
                >
                    <div
                        class="absolute inset-0 opacity-20"
                        :style="{
                            'background-color': cookie.buttonColor,
                            color: cookie.buttonColor,
                        }"
                    ></div>
                    <CookieIcon class="h-6 w-6" />
                </div>

                <div class="mt-4">
                    <cUtilsEdit @edit="goToContentAdjustField('cookieAdjustTitle')">
                        <h3
                            :style="{ color: cookie.textColor, 'font-family': cookie.fontFamily }"
                            class="text-lg font-semibold"
                            id="modal-title"
                        >
                            {{ cookie.adjustTitle }}
                        </h3>
                    </cUtilsEdit>
                    <div
                        class="mt-1 text-sm font-regular opacity-80"
                        :style="{ color: cookie.textColor }"
                    >
                        <p
                            :style="{
                                color: cookie.textColor,
                                'font-family': cookie.fontFamily,
                            }"
                        >
                            <cUtilsEdit class="inline" @edit="goToContentAdjustField('cookieDesc')">
                                <span>{{ cookie.desc }} {{}}</span>
                            </cUtilsEdit>
                            <a
                                :style="{
                                    color: cookie.textColor,
                                    'font-family': cookie.fontFamily,
                                }"
                                class="mt-2 underline"
                                v-if="cookie.policyLink"
                                :href="cookie.policyUrl"
                                @click.prevent="goToLink(cookie.policyUrl)"
                            >
                                {{ cookie.policyText }}
                            </a>
                        </p>
                    </div>
                    <div class="mt-5 text-sm" :style="{ color: cookie.textColor }">
                        <div v-for="type in consentTypes" :key="type">
                            <CookieCheck
                                @click="handleActionClick"
                                :data-ec-check="type"
                                v-if="!cookie.consentTypes?.[type]?.hide"
                                :label="
                                    cookie.consentTypes?.[type]?.name || defaultTypes[type].name
                                "
                                :info="cookie.consentTypes?.[type]?.info || defaultTypes[type].info"
                                :text="type === 'strict' ? $t('r_cookie.active') : ''"
                                :cookie="cookie"
                                :type="type"
                            />
                        </div>
                    </div>
                </div>

                <div class="mt-6 sm:mt-8 grid sm:grid-cols-2 gap-2 sm:gap-3">
                    <a
                        @click.prevent="showCookie"
                        data-ec-save
                        href="#"
                        :style="{
                            'background-color': cookie.buttonColor,
                            color: cookie.backColor,
                            'font-family': cookie.fontFamily,
                        }"
                        class="order-1 sm:order-2 w-full block text-center rounded-lg border border-transparent shadow-sm px-4 py-2.5 text-base font-medium hover:opacity-80"
                    >
                        {{ $t("r_cookie.accept_chosen") }}
                    </a>
                    <a
                        @click.prevent="showCookie"
                        v-if="cookie.cancelText"
                        data-ec-all
                        href="#"
                        :style="{
                            'border-color': cookie.buttonColor,
                            color: cookie.buttonColor,
                            'font-family': cookie.fontFamily,
                        }"
                        class="order-2 sm:order-1 w-full block text-center rounded-lg border hover:opacity-50 shadow-sm px-4 py-2.5 text-base font-medium"
                    >
                        {{ $t("r_cookie.accept_all") }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { COOKIE_PREVIEW_KIND } from "@/apps/cookie/cookie.routes";
import { CookieIcon, XIcon } from "@easy/ui/icons";
import CookieCheck from "./CookieCheck.vue";
import { cookiesService } from "@/apps/cookie/services/cookies.service";
import { handleActionClick } from "@/shared/utils";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import { useCookieGoTo } from "@/views/tools/cookie/utils/useCookieGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "AdjustBody",
    components: {
        CookieIcon,
        XIcon,
        CookieCheck,
        cUtilsEdit,
    },
    props: {
        cookie: Object,
        nonFixed: Boolean,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToContentAdjustField } = useCookieGoTo();
        return {
            goToLink,
            goToContentAdjustField,
        };
    },
    data() {
        return {
            consentTypes: cookiesService.getConsentTypes(),
        };
    },
    computed: {
        defaultTypes() {
            return cookiesService.getDefaultTypes();
        },
    },
    emits: ["updateIframeView"],
    methods: {
        handleActionClick,
        showCookie() {
            this.$emit("updateIframeView", COOKIE_PREVIEW_KIND.cookie);
        },
    },
};
</script>
